require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./coding-interview-prep-project-euler-problem-37-truncatable-primes.json") })
        }
      }, "path---coding-interview-prep-project-euler-problem-37-truncatable-primes");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---coding-interview-prep-project-euler-problem-37-truncatable-primes!./.cache/json/coding-interview-prep-project-euler-problem-37-truncatable-primes.json
// module id = 1656
// module chunks = 231608221292675